import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {CommentBdc} from '../../../common/services';

@Component({
  selector: 'app-comment-modale',
  templateUrl: './comment-modale.component.html',
  styleUrls: ['./comment-modale.component.scss']
})
export class CommentModaleComponent implements OnInit {

  constructor(@Inject(LOCALE_ID) private locale: string,
              @Inject(MAT_DIALOG_DATA) public data: CommentBdc,
              public dialogRef: MatDialogRef<CommentModaleComponent>) { }

  ngOnInit() {
  }

}
